
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    FM: "FM",
    HS: "HS",
    QC: "QC",
    QD: "QD",
    SF: "SF",
    SI: "SI",
    SM: "SM",
    MN: "MN",
    SY: "SY"
};
